angular.module('SpidApp')

.factory('ReceiptPrinter',
        ['$http', 'SPID_CONFIG', '$q',
function ($http,   SPID_CONFIG,   $q) {
	var CONFIG = SPID_CONFIG.devices.receiptPrinter

    var HOST = CONFIG.host
    var PORT = CONFIG.port
    
    var IS_MOCKED = CONFIG.isMocked
	
	var ReceiptPrinter = {
		getStatus: (IS_MOCKED ? function () {
			return $q(function (resolve) { resolve() })
		} : function () {
			return $http.get(HOST + ':' + PORT + '/receiptPrinter/status').then(function (response) {
				return $q(function (resolve) {
					resolve(response.data)
				})
			})
		}),
		print: function (data) {
			return $http.post(HOST + ':' + PORT + '/impTicket', { pdfToPrint: data }).then(function (response) {
				return $q(function (resolve, reject) {
					if (response.data === 'received') {
						resolve(response.data)
					}
					reject(response.data)
				})
			})
		}
	}

	return ReceiptPrinter
}])